<template>
  <form @submit.prevent="buscarTesteGabarito()" autocomplete="off">
    <b-row>
      <b-col cols="12" class="mt-4">
        <div class="titlePage mb-3">Teste</div>
      </b-col>
      <b-col cols="4">
        <fcc-select
          v-model="tipo"
          valueField="value"
          labelField="text"
          :clearable="false"
          :options="tiposBusca"
        >
          Tipo de Busca
        </fcc-select>
      </b-col>
      <b-col cols="6">
        <fcc-input v-model="campoBusca" v-mask="tipo ? '##########' : 'XXXXXXXXXX'" required
          >Dados</fcc-input
        >
      </b-col>
      <b-col cols="2">
        <fcc-button icon="search" tipo="submit" class="mb-3"> Buscar </fcc-button>
      </b-col>
      <b-col cols="12" v-if="permissao != null">
        <fcc-button
          :icon="liberarExportacao ? 'lock' : 'unlock-alt'"
          class="mb-4"
          @click="liberarGabaritosProvas"
          :disabled="liberarExportacao"
        >
          Liberar
        </fcc-button>
        <fcc-button
          icon="undo"
          class="mb-4 ml-2"
          @click="desfazerLiberacaoGabarito"
          :disabled="!liberarExportacao"
        >
          Desfazer
        </fcc-button>
      </b-col>
    </b-row>
    <fcc-tabela-gabarito
      :lstTesteGabarito="lstTesteGabarito"
      :visualizarProva="visualizarProva"
      :idNotificacao="idNotificacao"
      :gabarito="gabarito"
      :prova="prova"
    />
  </form>
</template>
<script>
import fccTabelaGabarito from './fccTabelaGabarito.vue'
import axios from 'axios'
import store from '@/store'
export default {
  data() {
    return {
      tiposBusca: [
        { value: false, text: 'N° do Caderno' },
        { value: true, text: 'N° do Pedido' }
      ],
      permissao: null,
      tipo: true,
      campoBusca: '',
      lstTesteGabarito: [],
      visualizarProva: []
    }
  },
  components: {
    fccTabelaGabarito
  },
  mounted() {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.permissao = this.permissaoPage.find((lista) => lista.objpermcodigo === 'X')
  },
  props: {
    idNotificacao: {
      type: String,
      default: ''
    },
    gabarito: {
      type: String,
      default: ''
    },
    prova: {
      type: String,
      default: ''
    },
    liberarExportacao: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    desfazerLiberacaoGabarito() {
      this.callConfirm(`Tem certeza que deseja desfazer liberação?`, '').then(() => {
        this.carregaTexto(this.codeMensagem('C03'))
        axios
          .post(
            this.baseUrlPublicacao + 'PublicacaoGabarito/DesfazerLiberacaoGabaritosProvas',
            this.idNotificacao,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.carregaTexto()
            this.$emit('listarLiberacao')
            this.callToast('Sucesso ao Desfazer!')
          })
          .catch(this.setErrorSystem)
      })
    },
    liberarGabaritosProvas() {
      this.callConfirm(`Tem certeza que deseja liberar?`, '').then(() => {
        this.carregaTexto(this.codeMensagem('C03'))
        axios
          .post(
            this.baseUrlPublicacao + 'PublicacaoGabarito/LiberacaoGabaritosProvas',
            this.idNotificacao,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.$emit('listarLiberacao')
            this.carregaTexto()
            this.callToast('Sucesso ao Liberar!')
          })
          .catch((error) => {
            this.carregaTexto()
            this.setErrorSystem(error)
          })
      })
    },
    buscarTesteGabarito() {
      this.lstTesteGabarito = []
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao +
            `PublicacaoGabarito/GabaritoTestePorNumeroPedidoOuCaderno/${this.idNotificacao}/${this.campoBusca}/${this.tipo}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          if (response.data.length) {
            this.callToast('Sucesso', 'success', 'success')
          } else {
            this.callToast('Sem resultados', 'error', 'error')
          }
          this.lstTesteGabarito = response.data
          this.$forceUpdate()
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  }
}
</script>
